import { isoToLocalDate } from "@jugl-web/utils";
import { OrderTaskDto } from "./OrderTaskDto";
import { OrderTaskFormFieldValue, OrderTaskModel } from "./OrderTaskModel";

export const transformOrderTaskDtoToModel = (
  dto: OrderTaskDto
): OrderTaskModel => {
  // Map form fields to a dictionary of id -> value
  // (analogously to task custom fields) for easier access
  const formFields = dto.resp.reduce<Record<string, OrderTaskFormFieldValue>>(
    (acc, field) => {
      acc[field.id] = field.value;
      return acc;
    },
    {}
  );

  return {
    assignees: dto.assignees,
    customFields: dto.custom_fields || {},
    customer: dto.customer,
    dueAt: dto.due_at ? isoToLocalDate(dto.due_at) : null,
    formFields,
    id: dto.id,
    insertedAt: isoToLocalDate(dto.inserted_at),
    totalItemsCount: dto.items_cnt,
    name: dto.name,
    orderId: dto.order_id,
    orderResponseId: dto.order_resp,
    reminderExecutionTime: dto.reminder
      ? isoToLocalDate(dto.reminder.next_execution)
      : null,
    status: dto.status,
    totalValue: dto.total,
    timezone: dto.tz,
  };
};
